import { resolveSlotSizeMm } from './photoQuality';
import { croppedFraction, normalizeFraming } from './framing';

// Part de la photo COUPEE par le remplissage dans un emplacement de page (0..1).
// Utilise par le point orange (surcouche de la page) et le panneau "photo
// selectionnee" : une seule facon de calculer, jamais deux.
export function slotCroppedFraction({ item, layoutSlug, slotIndex, printFormat, framing }) {
  const f = normalizeFraming(framing);
  if (!item || f.fit !== 'cover') return 0;
  const size = resolveSlotSizeMm(layoutSlug, slotIndex, printFormat);
  const width = item.metadata?.width;
  const height = item.metadata?.height;
  if (!size || !width || !height) return 0;
  return croppedFraction({ imageRatio: width / height, frameRatio: size.widthMm / size.heightMm, zoom: f.zoom });
}
